import { useEffect, useState, useCallback } from "react";
import useLanguage from "../common_hooks/useLanguage";
import MidtransContainer from "./MidtransContainer";

import icon_paypal from "../../Assets/svg/payment_paypal.svg";
import { create_payment } from "../../App/actions/paymentActions";
import { useDispatch, useSelector } from "react-redux";

function PaymentMethod({
  set_page,
  set_payment_id,
  set_error,
  // month,
  package_object,
}) {
  const [payment_method, set_payment_method] = useState("");
  const { dict, language } = useLanguage();

  const is_indonesia =
    useSelector((state) => state.auth.user.country || "Indonesia") ===
    "Indonesia";

  const dispatch = useDispatch();

  const handle_payment_method = (method) => {
    if (["midtrans", "paypal"].includes(method)) {
      set_payment_method(method);
    }
  };

  // Wrap the function with useCallback to stabilize its reference
  const on_create_midtrans_payment = useCallback(async () => {
    set_page({ new_page: "loading" });
    const { month, package_type, licenses, collaborators } = package_object;

    const body = {
      package_type,
      license_includes: licenses.map((item) => ({
        license_key: item,
        month: month,
      })),
      currency: "IDR",
      collaborators: collaborators - 1,
      payment_methode: "midtrans",
    };

    let response = "";
    response = await dispatch(create_payment(body));

    if (response?.status === 200 && response?.id) {
      set_payment_id(response?.id);
      set_page({ new_page: "payment" });
    } else {
      set_page({ new_page: "error" });
      set_error(response);
    }
  }, [dispatch, package_object, set_page, set_payment_id, set_error]);

  // Add the dependencies to the useEffect
  useEffect(() => {
    if (is_indonesia) {
      on_create_midtrans_payment();
    }
  }, [is_indonesia, on_create_midtrans_payment]);

  const on_create_paypal_payment = async () => {
    const { month, package_type, licenses, collaborators } = package_object;
    set_page({ new_page: "loading" });
    const body = {
      package_type,
      license_includes: licenses.map((item) => ({
        license_key: item,
        month: month,
      })),
      currency: "USD",
      collaborators: collaborators - 1,
      payment_methode: "paypal",
    };

    const response = await dispatch(create_payment(body));

    if (response?.status === 200 && response?.id) {
      set_payment_id(response?.id);
      set_page({ new_page: "payment" });
    } else {
      set_page({ new_page: "error" });
      set_error(response);
    }
  };

  // const is_midtrans = payment_method === "midtrans";
  const is_paypal = payment_method === "paypal";

  return (
    <>
      <div className="flex justify_center gap_20 wrap">
        {is_indonesia && (
          <section>
            <MidtransContainer />
            <button
              className="button_big background_black w_full"
              onClick={() => {
                on_create_midtrans_payment();
              }}
            >
              {dict["Pay"][language]}
            </button>
          </section>
        )}

        {!is_indonesia && (
          <section
            className={`card_license noselect w_300 gap_10 ${
              is_paypal ? "active_card" : ""
            }`}
            onMouseEnter={() => handle_payment_method("paypal")}
          >
            <section
              style={{ height: "100%" }}
              className="flex flex_col justify_center"
            >
              <img src={icon_paypal} alt="paypal" />
            </section>

            <button
              onClick={() => {
                if (is_paypal) {
                  on_create_paypal_payment();
                }
              }}
            >
              {dict["Choose"][language]}
            </button>
          </section>
        )}
      </div>
    </>
  );
}

export default PaymentMethod;
